module.exports = __webpack_public_path__ + "img/formentea2-min.2c4861b3.jpg";